var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTesla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_394",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29011",
    "data-name": "Group 29011",
    transform: "translate(-3746 4996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3746, -4996)",
    filter: "url(#Ellipse_394)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_394-2",
    "data-name": "Ellipse 394",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-tesla",
    transform: "translate(3764 -4982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50591",
    "data-name": "Path 50591",
    d: "M5.271,9.632c3.7-1.5,9.8-1.693,12.451-1.593l1.7,2.178,1.7-2.178c2.651-.1,8.752.094,12.45,1.593a8.155,8.155,0,0,1-3.953,2.656c-.069-1.906-2.763-2.3-5.347-2.3l-4.848,26-4.847-26c-2.587,0-5.281.4-5.35,2.3A8.141,8.141,0,0,1,5.271,9.632Z",
    transform: "translate(-0.556 -0.983)",
    fill: "#b71c1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50592",
    "data-name": "Path 50592",
    d: "M3,6.065l.946,1.389a41.736,41.736,0,0,1,12.348-2c1.7-.052,3.435-.052,5.135,0a41.692,41.692,0,0,1,12.349,2l.947-1.389A44.762,44.762,0,0,0,21.482,4.033c-1.743-.045-3.5-.045-5.237,0A44.762,44.762,0,0,0,3,6.065Z",
    fill: "#b71c1c",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesla);
export default __webpack_public_path__ + "static/media/tesla.e41248c77e621d168b1d00e6f11013b7.svg";
export { ForwardRef as ReactComponent };